<template>
  <div class="data-card py-2">
    <el-collapse v-model="activeCollapses" class="el-collapse--no-border">
      <el-collapse-item name="1" class="no-arrow">
        <template slot="title">
          <collapse-custom-arrow :isActive="activeCollapses.includes('1')">
            <h3 class="mt-0">Записи звонков</h3>
          </collapse-custom-arrow>
        </template>

        <el-table size="small" :data="form.calls" max-height="100%" border>
          <el-table-column prop="callType" label="Тип звонка" min-width="280">
            <template slot-scope="{row}">
              {{getCallTypeTitle(row.callType)}}
            </template>
          </el-table-column>
          <el-table-column prop="callStatusId" label="Статус" min-width="240">
            <template slot-scope="{row}">
              {{getCallStatusTitle(row.callStatusId)}}
            </template>
          </el-table-column>
          <el-table-column prop="recordFile" label="Файл записи" min-width="300">
            <template slot-scope="{row}">
              <div v-if="row.recordFile" class="d-flex align-items-center flex-gap-10">
                <audio controls controlslist="noplaybackrate nodownload" :src="row.recordFile.fileUrl" />
                <el-tooltip placement="right" effect="light">
                  <template slot="content">
                    <span v-if="isFirefox">
                      Для скачивания звонка <br> нажмите правой кнопкой мыши на плеере <br> и выберите "Сохранить аудио как..."
                    </span>
                    <span v-else>Скачать запись</span>
                  </template>
                  <a class="border-circle" download target="_blank" :href="row.recordFile.fileUrl">
                    <el-button type="secondary" size="small" icon="el-icon-download" circle :disabled="isFirefox"/>
                  </a>
                </el-tooltip>
              </div>
              <span v-else>Нет</span>
            </template>
          </el-table-column>
          <el-table-column prop="callStartedDT" label="Дата и время начала звонка" min-width="220">
            <template slot-scope="{row}">
              {{ row.callStartedDT ? dateFormatToMoscowTime(row.callStartedDT ) : '' }}
            </template>
          </el-table-column>
          <el-table-column prop="callEndedDT" label="Дата и время завершения звонка" min-width="260">
            <template slot-scope="{row}">
              {{ row.callEndedDT ? dateFormatToMoscowTime(row.callEndedDT) : '' }}
            </template>
          </el-table-column>
          <el-table-column prop="workerFullName" label="Исполнитель" min-width="240" />
        </el-table>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { formatPrice, dateFormatToMoscowTime, isFirefox } from '@/commons/helpers';

export default {
  props: {
    isEdited: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    activeCollapses: [],

    form: {
      calls: [],
    },
  }),
  created() {
    this.fillForm();
  },
  computed: {
    ...mapGetters({
      item: 'orders/item',
    }),
    isFirefox() {
      return isFirefox();
    },
  },
  methods: {
    formatPrice,
    fillForm() {
      if (this.item && this.item.calls) {
        this.form.calls = [...this.item.calls];
      } else {
        this.form.calls = [];
      }
    },
    getCallTypeTitle(callType) {
      switch (callType) {
        case 1: return 'Исполнитель → Клиент (осн. номер)';
        case 2: return 'Исполнитель → Клиент (доп.номер)';
        case 3: return 'Исполнитель → Клиентская служба';
        case 4: return 'Клиент → Исполнитель';
        default: return '';
      }
    },
    getCallStatusTitle(callStatusId) {
      if (typeof callStatusId === 'undefined' || callStatusId === null) {
        return 'Не определен';
      }
      switch (callStatusId) {
        case 0:
        case 1: return 'Звонок не состоялся';
        case 2:
        case 3: return 'Звонок состоялся';
        case 5:
        case 6:
        case 7: return 'Клиент не ответил на звонок';
        default: return 'Звонок не состоялся';
      }
    },
    dateFormatToMoscowTime,
  },
  watch: {
    item() {
      this.fillForm();
    },
  },
};
</script>
<style scoped>
audio {
  width: 100%;
  height: 32px;
}
</style>
